const FIPE_BASE_URL = process.env.REACT_APP_FIPE_API_URL || 'https://parallelum.com.br/fipe/api/v1/carros/marcas';

export const fetchBrands = async () => {
  const response = await fetch(FIPE_BASE_URL, {
    method: 'GET',
    redirect: 'follow',
  })
    .then((res) => res.json())
    .catch((error) => console.log('error', error));

  return Array.isArray(response) ? response : [];
};

export const fetchModels = async (brandCode) => {
  if (!brandCode || typeof brandCode !== 'string') return [];

  const response = await fetch(`${FIPE_BASE_URL}/${brandCode}/modelos`, {
    method: 'GET',
    redirect: 'follow',
  })
    .then((res) => res.json())
    .catch((error) => console.log('error', error));

  if (response && !response?.error && Array.isArray(response.modelos)) {
    return response.modelos;
  }
  return [];
};
